import * as React from 'react';



export default class Reports extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      
      <svg className={this.props.className} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_3496_6398" fill="white" strokeWidth="0">
      <rect x="0.0769043" y="0.00735474" width="16.62" height="18" rx="1"/>
      </mask>
      <rect x="0.0769043" y="0.00735474" width="16.62" height="18" rx="1" stroke="#333"  strokeWidth="3" mask="url(#path-1-inside-1_3496_6398)"/>
      <path d="M3.64008 14.5074L5.73715 12.5074L7.30995 13.0074L8.88276 11.0074L10.4556 12.0074L12.0284 10.5074" stroke="#333" strokeWidth="1"/>
      <path d="M3.64008 8.50735V14.5074H13.0769" stroke="#333" strokeWidth="1"/>
      <line x1="3.0769" y1="3.00735" x2="13.0769" y2="3.00735" stroke="#333" strokeWidth="1"/>
      <line x1="3.0769" y1="5.00735" x2="13.0769" y2="5.00735" stroke="#333" strokeWidth="1"/>
      <line x1="3.0769" y1="7.00735" x2="8.0769" y2="7.00735" stroke="#333" strokeWidth="1"/>
      </svg>
    )
  }
}





